import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Table, Button, Row, Card } from "react-bootstrap";
import {
  getCourseTypes,
  deleteCourseType,
} from "../../../../services/CourseTypeService";

const CourseTypeList = () => {
  const [courseType, setCourseType] = useState([]);

  useEffect(() => {
    getCourseTypes()
      .then((data) => setCourseType(data))
      .catch((error) => console.error(error));
  }, []);

  const onDelete = (id) => {
    deleteCourseType(id)
      .then(() => setCourseType(courseType.filter((type) => type._id !== id)))
      .catch((error) => console.error(error));
  };

  return (
    <div>
      <Card>
      <h2 style={{color:"black"}}>Course Types</h2>
      <div className="d-flex justify-content-end">
      <Link to="/settings/coursetype/add">
        <Button variant="primary" className="mb-3">
          Add Course Type
        </Button>
        
      </Link>
      </div>
      <Table>
        <thead>
          <tr>
            <th>Label</th>
            <th>Value</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {courseType.map((type) => (
            <tr key={type._id}>
              <td>{type.label}</td>
              <td>{type.value}</td>
              <td>
                <Link to={`/settings/coursetype/edit/${type._id}`}>
                  <Button
                    variant="warning"
                    title="View"
                    className="btn btn-primary shadow btn-xs sharp me-1"
                    style={{background:"#3a7afe", border:"none"}}
                   
                  >
                    <i className="fa fa-pencil"></i>
                  </Button>
                </Link>{" "}
                <Button
                  onClick={() => onDelete(type._id)}
                  title="Delete"
                  className="btn btn-danger shadow btn-xs sharp"
                  
                >
                  <i className="fa fa-trash"></i>
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
      </Card>
    </div>
  );
};

export default CourseTypeList;
